export default __webpack_public_path__ + "static/media/4.9f7ea2f2.jpg";